import React, { memo, useCallback } from 'react';
import { FormSelect } from '@core/components/form';
import { useBloc } from '@core/utils/bloc';
import { ProcedureWidgetForm, ProcedureBlockVariation } from './ProcedureBlock';
import { ProcedureBlockBloc } from './ProcedureBlockBloc';
import { CompactLibraryItemResponse, LibraryItemOptionResponse } from '@business/entities/library';
import { useLibraryItemSelect } from '../Common/LibraryItemSelect';

export interface EmbedBlockSettingsProps {
  form: ProcedureWidgetForm;
  variation: ProcedureBlockVariation;
}

export const ProcedureBlockSettings = memo((props: EmbedBlockSettingsProps) => {
  const { form, variation } = props;
  const bloc = useBloc(ProcedureBlockBloc, variation);

  const apply = useCallback(
    (item: CompactLibraryItemResponse, procedure: LibraryItemOptionResponse) => {
      try {
        const json = JSON.parse(item.content as string);
        form.patchValue({ text: json[0], heading: procedure.name });
      } catch (e) {
        form.patchValue({ text: item.content as string, heading: procedure.name });
      }
    },
    [form],
  );

  const { items, onChange, noOptionsMessage } = useLibraryItemSelect(bloc, form.controls.id, 'procedures', apply);

  return (
    <div>
      <FormSelect control={form.controls.id} items={items} onChange={onChange} noOptionsMessage={noOptionsMessage} />
    </div>
  );
});
